import type { JSX } from 'react';

import Image from 'next/image';

import Body from 'DesignSystem3/Text/Body';

interface ProbabilityBarHeaderProps {
    isIndependent?: boolean;
    isPresidency?: boolean;
    imageSize?: number;
}

const ProbabilityBarHeader = ({
    isIndependent = false,
    isPresidency = false,
    imageSize = 32,
}: ProbabilityBarHeaderProps): JSX.Element => {
    return (
        <div className="flex justify-between w-full">
            <div className="flex text-red-x10 gap-1 items-center">
                <Image
                    src={isPresidency ? '/images/elections_dash/Trump.webp' : '/images/elections_dash/rep-logo.webp'}
                    alt="Republican party logo"
                    height={imageSize}
                    width={imageSize}
                />
                <Body.x30>{isPresidency ? 'Trump' : 'Republican'}</Body.x30>
            </div>
            <div className={'flex gap-1 items-center' + (isIndependent ? ' text-purple-x10' : ' text-blue-x10')}>
                <Body.x30>{isIndependent ? 'Independent' : isPresidency ? 'Harris' : 'Democratic'}</Body.x30>
                {isIndependent ? (
                    <div className="flex items-center justify-center font-bold w-2 h-2 rounded-x50 text-[10px] border-2 border-solid border-purple-x10">
                        I
                    </div>
                ) : (
                    <Image
                        src={
                            isPresidency ? '/images/elections_dash/Kamala.webp' : '/images/elections_dash/dem-logo.webp'
                        }
                        alt={isIndependent ? 'Independent party logo' : 'Democratic party logo'}
                        height={imageSize}
                        width={imageSize}
                    />
                )}
            </div>
        </div>
    );
};

export default ProbabilityBarHeader;
